import React from 'react';
import PropTypes from 'prop-types';

import './CommonTableRow.css';

const CommonTableRow = ({ children, className }) => {
  const calculateClassname = () => {
    let value = 'common-table-row__component';
    if (className) { value += ` ${className}`; }
    return value;
  };

  return (
    <div className={calculateClassname()}>
      {children}
    </div>
  );
};

CommonTableRow.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]).isRequired,
  className: PropTypes.string,
};

CommonTableRow.defaultProps = {
  className: null,
};

export default CommonTableRow;
